import React from "react";
import { FormComponent } from "../../../react-core/Html/FormComponent";
import { RadiosEditor } from "../../../react-core/Html/RadiosEditor";
import { CustomerStatus } from "../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { UserClaim } from "../../../Wrap/Constants/Enums/UserClaim";
import { CustomerNewProductLink } from "../../../Wrap/Models/Models/Customer/CustomerNewProductLink";
import { PersonalDetail } from "../../../Wrap/Models/Models/Customer/PersonalDetail";
import { Alert } from "../../Shared/Components/Alert";
import { AlertType } from "../../Shared/Entities/Constants/AlertConstants";
import { Permission } from "../../Shared/Permission/Permission";
import { ClientRecordTab } from "./Clients/ClientRecord/Resource/Contents";
import { ClientRecordStore } from "./Clients/ClientRecord/Store/Variable";
import { ClientAccount } from "../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { User } from "../../../Wrap/Models/Models/User/User";
import { UserStore } from "../Stroes/Variable";
import { SubAccountType } from "../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { Action } from "../Actions/Action";

interface ISelectAccountLightboxProps {
    errorMsg: string;
    links: CustomerNewProductLink[];
    customerId: number;
    displayNewBusiness: boolean;
}

interface ISelectAccountLightboxState {
    selectedAccount: CustomerNewProductLink;
    clientdetail: PersonalDetail;
    userInfo: User;
    errorMsg: string;
}

export class SelectAccountLightbox extends FormComponent<ISelectAccountLightboxProps, ISelectAccountLightboxState> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedAccount: null,
            clientdetail: ClientRecordStore.getData()?.[ClientRecordTab.PersonalDetail],
            userInfo: UserStore.getUserInfo(),
            errorMsg: this.props.errorMsg
        };
        this.subscribeToStore(ClientRecordStore, () => {
            this.setState({ clientdetail: ClientRecordStore.getData()?.[ClientRecordTab.PersonalDetail] });
        });
    }

    private async hasDpcSubAccount() {
        const nprSubaccount = this.state.selectedAccount?.Account?.SubAccounts?.find((item) => item.SubAccountType == SubAccountType.Npr);
        if (!nprSubaccount) return false;

        const pensionSubAccountSettings = await Action.getPensionSubAccountSettings(nprSubaccount.HierarchyId, true);
        return pensionSubAccountSettings?.HasDisqualifyingPensionCredit;
    }

    public render(): JSX.Element {
        return (
            <>
                {this.state.errorMsg || this.state.clientdetail?.CustomerStatus == CustomerStatus.Deceased ? (
                    <Alert alertType={AlertType.Error} message={this.state.errorMsg} />
                ) : (
                    <>
                        <div>
                            <RadiosEditor
                                options={this.props.links}
                                selected={this.state.selectedAccount}
                                onChange={(v) => {
                                    this.setState({
                                        selectedAccount: v,
                                    });
                                }}
                                getText={(o) => `${o.Account?.AccountName} - ${o.Account?.HeadClAccountId}`}
                            />
                            <br />
                            {this.state.selectedAccount && !this.state.selectedAccount?.IsActive && (
                                <Alert alertType={AlertType.Error} message={this.state.errorMsg} />
                            )}
                            <button
                                className="btn secondary mt-5"
                                onClick={() => {
                                    this.hasDpcSubAccount().then(v => {
                                        if (v && this.state.userInfo?.IsAdviser)
                                        {
                                            this.setState({
                                                errorMsg: 'New product journey not available for this type of Account.'
                                            })
                                        } 
                                        else {
                                            window.location.assign(this.state.selectedAccount.Link);
                                        } 
                                    })
                                }}
                                disabled={ !this.state.selectedAccount || !this.state.selectedAccount.IsActive }
                            >
                                Next
                            </button>
                        </div>
                        {this.props.displayNewBusiness && (
                            <Permission userClaim={UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite}>
                                <>
                                    <br />
                                    OR
                                    <br />
                                    <button
                                        className="btn secondary mt-10"
                                        onClick={() =>
                                            window.location.assign(
                                                "/wpadviser/en-gb/dashboard/home/main/client/new-business/full-client-detail?customerid=" +
                                                    this.props.customerId
                                            )
                                        }
                                    >
                                        Create new account
                                    </button>
                                </>
                            </Permission>
                        )}
                    </>
                )}
            </>
        );
    }
}
